export default {
  setFormId(state, formId) {
    state.formId = formId;
  },
  setWorkData(state, workData) {
    state.workData = workData;
  },
  setEducationData(state, educationData) {
    state.educationData = educationData;
  }
};
